module.exports = {
	"app-store": "App Store"
};


//////////////////
// WEBPACK FOOTER
// ./src/data/sanitizedCTAs.json
// module id = 214
// module chunks = 5